<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-picture-o mr-2" />Carousel Promo
            </h5>
            <hr />
            <b-row>
                <!-- <b-col md="3">
                    <b-form-group label="Nama Admin">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col> -->
                <b-col md="12" class="text-right">
                    <b-form-group>
                        <b-button
                            variant="success"
                            :disabled="isBusy || isSubmitting"
                            @click="prepareCreate"
                        >
                            <i class="fa fa-plus mr-2" />Carousel Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty> Tidak ada data admin. </template>
                <template v-slot:cell(active)="row">
                    <b-badge variant="success" v-if="row.item.is_active == 1"
                        >Aktif</b-badge
                    >
                    <b-badge variant="danger" v-else>Nonaktif</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="d-flex">
                        <b-button
                            size="sm"
                            variant="warning"
                            v-b-tooltip.hover.top
                            title="Edit"
                            :disabled="isBusy || isSubmitting"
                            @click="prepareEdit(row.item)"
                        >
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            :variant="
                                row.item.is_active == 1 ? 'danger' : 'success'
                            "
                            v-b-tooltip.hover.top
                            :title="
                                row.item.is_active == 1
                                    ? 'Nonaktifkan'
                                    : 'Aktifkan'
                            "
                            :disabled="
                                (row.item.role_id == 1 &&
                                    row.item.is_active == 1) ||
                                isBusy ||
                                isSubmitting
                            "
                            @click="confirmToggle(row.item)"
                        >
                            <i class="fa fa-fw fa-power-off" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            variant="danger"
                            :disabled="isBusy || isSubmitting"
                            v-b-tooltip.hover.top
                            title="Hapus"
                            @click="confirmDelete(row.item)"
                        >
                            <i class="fa fa-fw fa-times" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
        <b-modal
            id="m-create"
            size="lg"
            title="Buat Carousel Baru"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-alert show variant="warning"
                >Rekomendasi ukuran gambar adalah 1310px * 260px</b-alert
            >
            <b-img-lazy
                v-if="$helper.isBlank(input.image_path)"
                class="preview-image"
                src="/img/img-preview.png"
            ></b-img-lazy>
            <b-img-lazy
                v-else
                class="preview-image"
                :src="input.image_path"
            ></b-img-lazy>
            <div
                v-if="$helper.isBlank(input.image)"
                class="d-block invalid-feedback"
            >
                Mohon upload gambar.
            </div>
            <b-button
                variant="primary"
                class="mt-3 mb-3"
                :disabled="isSubmitting"
                @click="$refs.fileuploadinput.click()"
            >
                Upload Gambar
            </b-button>
            <b-form-group
                label="Nama Carousel Promo"
                :state="inputNameState"
                invalid-feedback="Nama minimal 4 karakter."
            >
                <b-form-input
                    v-model="input.name"
                    :state="inputNameState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Urutan Carousel Promo"
                :state="inputOrderState"
            >
                <b-form-input
                    v-model="input.order"
                    type="number"
                    :state="inputOrderState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Deskripsi"
                :state="inputDescState"
                invalid-feedback="Deskripsi minimal 4 karakter."
            >
                <b-form-textarea
                    v-model="input.description"
                    :state="inputDescState"
                    class="hide-scrollbar"
                    rows="3"
                    max-rows="5"
                    maxlength="1000"
                />
            </b-form-group>

            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="
                        !(
                            inputImageState &&
                            inputNameState &&
                            inputDescState
                        ) ||
                        isSubmitting ||
                        isBusy
                    "
                    @click="confirmCreate"
                >
                    {{ isSubmitting ? "Membuat..." : "Buat Carousel" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="m-edit"
            size="lg"
            title="Ubah Data Carousel"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-alert show variant="warning"
                >Rekomendasi ukuran gambar adalah 1310px * 260px</b-alert
            >
            <b-img-lazy
                class="preview-image mb-3"
                :src="edit.image_path"
            ></b-img-lazy>
            <b-button
                variant="primary"
                class="mb-3"
                @click="$refs.fileuploadedit.click()"
                :disabled="isSubmitting"
            >
                Ubah Gambar
            </b-button>
            <b-form-group
                label="Nama Carousel Promo"
                :state="editNameState"
                invalid-feedback="Nama minimal 4 karakter."
            >
                <b-form-input
                    v-model="edit.name"
                    :state="editNameState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group label="Urutan Carousel Promo" :state="editOrderState">
                <b-form-input
                    v-model="edit.order"
                    :state="editOrderState"
                    type="number"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Deskripsi"
                :state="editDescState"
                invalid-feedback="Deskripsi minimal 4 karakter."
            >
                <b-form-textarea
                    v-model="edit.description"
                    :state="editDescState"
                    class="hide-scrollbar"
                    rows="3"
                    max-rows="5"
                    maxlength="1000"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="
                        !(editNameState && editDescState) ||
                        isSubmitting ||
                        isBusy
                    "
                    @click="confirmEdit(edit, items)"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan Perubahan" }}
                </b-button>
            </div>
        </b-modal>
        <input
            style="opacity: 0; filter: alpha(opacity=0)"
            ref="fileuploadinput"
            type="file"
            @change="onFileChangeInput"
            accept="image/png, image/jpeg"
        />
        <input
            style="opacity: 0; filter: alpha(opacity=0)"
            ref="fileuploadedit"
            type="file"
            @change="onFileChangeEdit"
            accept="image/png, image/jpeg"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            // filter: {
            //     name: "",
            // },

            input: {
                name: "",
                description: "",
                image_path: "",
                order: 0,
                image: null,
            },

            edit: {
                id: "",
                name: "",
                order: 0,
                description: "",
                image_path: "",
                image: null,
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],

            fields: [
                // { key: "name", label: "Nama Admin", sortable: true },
                // { key: "email", label: "Email", sortable: true },
                {
                    key: "name",
                    thStyle: { width: "20%" },
                    // tdClass: "w-25",
                    label: "Nama Promo Carousel",
                    sortable: true,
                },
                {
                    key: "description",
                    thStyle: { width: "32%" },
                    // tdClass: "w-25",
                    label: "Deskripsi",
                    sortable: true,
                },
                {
                    key: "order",
                    thStyle: { width: "20%" },
                    // tdClass: "w-25",
                    label: "Order",
                    sortable: true,
                },
                {
                    key: "active",
                    // thStyle: { width: "8%" },
                    tdClass: "w-auto",
                    label: "Status",
                    sortable: true,
                },
                {
                    key: "action",
                    // thStyle: { width: "20%" },
                    tdClass: "w-auto",
                    label: "Aksi",
                },
            ],

            items: [],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },

        prepareCreate() {
            this.input.name = "";
            this.input.description = "";
            this.input.image_path = "";
            this.input.image = null;
            this.$refs.fileuploadinput.value = null;
            this.$bvModal.show("m-create");
        },

        confirmCreate() {
            let data = new FormData();
            console.log(this.input);

            data.append("name", this.input.name);
            data.append("description", this.input.description);
            data.append("order", this.input.order);
            data.append("file", this.input.image);

            this.isSubmitting = true;

            this.$axios
                .post("admin/carousel", data)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Carousel baru berhasil dibuat!"
                    );
                    this.$bvModal.hide("m-create");
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        prepareEdit(item) {
            this.edit.id = item.id;
            this.edit.name = item.name;
            this.edit.order = item.order;
            this.edit.description = item.description;
            this.edit.image_path = this.$BASE_FILE_PATH + item.image_path;
            this.edit.image = null;
            this.$refs.fileuploadedit.value = null;
            this.$bvModal.show("m-edit");
        },

        confirmEdit(edit, items) {
            let data = new FormData();

            const dataEdit = items.filter((item) => item.id === edit.id);

            data.append("name", this.edit.name);
            if (this.edit.order !== dataEdit[0].order) {
                data.append("order", this.edit.order);
            }
            data.append("description", this.edit.description);
            if (!this.$helper.isBlank(this.edit.image)) {
                data.append("file", this.edit.image);
            }

            this.isSubmitting = true;

            this.$axios
                .post("admin/updateCarousel/" + this.edit.id, data)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Data carousel berhasil diubah!"
                    );
                    this.$bvModal.hide("m-edit");
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        confirmToggle(item) {
            let action = item.is_active == 1 ? "nonaktif" : "aktif";

            let isConfirmed = confirm(
                "Apakah anda yakin ingin meng" +
                    action +
                    'kan Carousel "' +
                    item.name +
                    '"?'
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            let payload = {
                is_active: item.is_active ? "false" : "true",
            };

            this.$axios
                .post("admin/updateCarousel/" + item.id, payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Carousel berhasil di" + action + "kan!"
                    );
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        confirmDelete(item) {
            let isConfirmed = confirm(
                "Apakah anda yakin ingin menghapus Carousel ini? Proses ini tidak dapat dibatalkan!"
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            this.$axios
                .delete("admin/carousel/" + item.id)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Carousel berhasil dihapus!"
                    );
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            // if (!this.$helper.isBlank(this.filter.name)) {
            //     param += "&name=" + this.filter.name;
            // }

            if (!this.$helper.isBlank(this.sortBy)) {
                param +=
                    "&sortBy=" +
                    (this.sortBy === "active" ? "is_active" : this.sortBy);
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("admin/carousel" + param)
                .then((res) => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                    // sessionStorage.setItem("listCarouselFilter", JSON.stringify(this.filter))
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        onFileChangeInput(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            else if (files[0].size > this.$uploadLimit) {
                this.$helper.toastError(
                    this,
                    "Ukuran gambar tidak boleh melebihi 5MB!"
                );
                return;
            }
            this.input.image = files[0];
            this.input.image_path = URL.createObjectURL(files[0]);
            console.log(this.input);
        },
        onFileChangeEdit(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            else if (files[0].size > this.$uploadLimit) {
                this.$helper.toastError(
                    this,
                    "Ukuran gambar tidak boleh melebihi 5MB!"
                );
                return;
            }
            this.edit.image = files[0];
            this.edit.image_path = URL.createObjectURL(files[0]);
        },
    },

    computed: {
        inputImageState() {
            if (this.$helper.isBlank(this.input.image)) {
                return false;
            }
            return true;
        },
        inputNameState() {
            if (this.input.name.length <= 0) return null;
            return this.input.name.length >= 4;
        },
        inputOrderState() {
            // if (this.input.order >= 0) return null;
            return this.input.order >= 1;
        },
        inputDescState() {
            if (this.input.description.length <= 0) return null;
            return this.input.description.length >= 4;
        },
        editNameState() {
            if (this.edit.name.length <= 0) return null;
            return this.edit.name.length >= 4;
        },
        editOrderState() {
            // if (this.edit.order.length <= 0) return null;
            return this.edit.order >= 1;
        },
        editDescState() {
            if (this.edit.description.length <= 0) return null;
            return this.edit.description.length >= 4;
        },
    },

    created() {
        // if(!this.$helper.isBlank(sessionStorage.getItem("listCarouselFilter"))){
        //     this.filter = JSON.parse(sessionStorage.getItem("listCarouselFilter"))
        // }
        this.init();
    },
};
</script>

<style scoped>
.preview-image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    aspect-ratio: 4 / 1;
    max-height: 450px;
}
.hide-scrollbar {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
}
.hide-scrollbar::-webkit-scrollbar {
    /* WebKit */
    display: none;
    width: 0;
    height: 0;
}
</style>
